import NetResourceRepository from '../../NetResourceRepository';
import NetResourceRepositoryAdapter from '../../NetResourceRepositoryAdapter';

import CurrentUserMapper, {
  CurrentUserData,
} from '../../../entities/mappers/writer/CurrentUserMapper';

import CurrentUser from '../../../../domain/entities/writer/CurrentUser';
import RegistrationRepository from '../../../../domain/repositories/writer/temporary_users/RegistrationRepository';

export default class NetRegistrationRepository
  extends NetResourceRepository<CurrentUser, CurrentUserData>
  implements RegistrationRepository
{
  constructor() {
    super(
      new NetResourceRepositoryAdapter(
        '/api/writer/temporary_users/registration',
        new CurrentUserMapper(),
      ),
    );
  }
}
